<template>
  <div>
    <div v-if="addUpdate">
      <!--      <StoppageAddUpdate v-bind:stoppageId="stoppageId" @close="close" @getAllStoppages="getAllStoppages"/>-->
      <StoppageAddUpdateModal
        v-bind:stoppage="stoppageId"
        v-bind:company="pagination.companyId"
        @close="close"
        @getAllStoppages="getAllStoppages"
      />
    </div>
    <div v-if="boardingPlace">
      <BoardingPlace
        v-bind:stoppageId="stoppageId"
        :stoppageName="stoppageName"
        @close="close"
        @toggle="toggle"
      />
    </div>
    <div v-else-if="droppingPlace">
      <DroppingPlace
        v-bind:stoppageId="stoppageId"
        :stoppageName="stoppageName"
        @close="close"
        @toggle="toggle"
      />
    </div>
    <div v-else>
      <FilterTab>
        <!-- <template v-slot:title><h6>Stoppage</h6></template> -->
        <template v-slot:body>
          <div class="col-sm-6 col-md-2"></div>
        </template>
        <template v-if="hasPermission(Admin.companyDeployWrite)" v-slot:button1>
          <button class="edit_table_data font_detail" @click="addModal">
            <i class="fas fa-plus"></i><span class="mx-1 bold">Add New</span>
          </button>
        </template>
      </FilterTab>
      <Table v-if="$store.getters.getStoppages">
        <template v-slot:header>
          <tr>
            <td class="font_detail">SL</td>
            <td class="font_detail">SEQUENCE</td>

            <td class="font_detail">NAME</td>
            <td class="font_detail">CITY</td>
            <td class="font_detail">BOARDING PLACES</td>
            <td class="font_detail">DROPPING PLACES</td>
            <td class="font_detail">STATUS</td>
            <td
              v-if="hasPermission(Admin.companyDeployWrite)"
              class="font_detail"
            >
              ACTION
            </td>
          </tr>
        </template>
        <template v-slot:body>
          <tr
            v-for="(stoppage, index) in $store.getters.getStoppages"
            :key="stoppage._id"
          >
            <td class="font_detail">
              {{ index + 1 + (pagination.page - 1) * 25 }}
            </td>
            <td class="font_detail">#{{ stoppage.sequence }}</td>

            <td class="font_detail">{{ stoppage.name }}</td>
            <td class="font_detail">{{ $store.getters.getDigitalTicketingAllStoppages[stoppage.dtCity] }}</td>

            <td class="font_detail">
              <button
                class="edit_table_data font_detail add_table_button px-2"
                @click="
                  updateBoardingPlace(
                    stoppage._id,
                    stoppage.defaultBoardingPlace,
                    stoppage.name
                  )
                "
              >
                <i class="fas fa-map-marker-alt"></i
                ><span class="mx-1">Create</span>
              </button>
            </td>
            <td class="font_detail">
              <button
                class="edit_table_data font_detail add_table_button px-2"
                @click="
                  updateDroppingPlace(
                    stoppage._id,
                    stoppage.defaultDroppingPoint,
                    stoppage.name
                  )
                "
              >
                <i class="fas fa-map-marker-alt"></i
                ><span class="mx-1">Create</span>
              </button>
            </td>
            <td>
              <span v-if="stoppage.status" class="badge bg-success">{{
                dropdownVariables.status[1]
              }}</span>
              <span v-else class="badge bg-danger">{{
                dropdownVariables.status[0]
              }}</span>
            </td>

            <td v-if="hasPermission(Admin.companyDeployWrite)">
              <button
                class="edit_table_data font_detail edit_table_button"
                @click="updateModal(stoppage._id)"
              >
                <i class="fas fa-edit"></i><span class="mx-1">Edit</span>
              </button>
            </td>
          </tr>
        </template>
        <template v-slot:pagination>
          <pagination
            v-model="pagination.page"
            :records="$store.getters.getTotalStoppages"
            :per-page="pagination.limit"
            @paginate="getAllStoppages"
            :options="options"
          />
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { reactive } from "@vue/reactivity";
import { inject, onBeforeMount, ref } from "vue";
import store from "@/store";
import dropdownVariables from "@/modules/dropdownVariables";
import { useRoute } from "vue-router";
import StoppageAddUpdateModal from "./StoppageAddUpdateModal";
import permission from "@/modules/permission";
import roles from "@/modules/roles";
import BoardingPlace from "./BoardingPlace/BoardingPlace.vue";
import DroppingPlace from "./DroppingPlace/DroppingPlace";

const { hasPermission } = permission();
const { Admin } = roles();

export default {
  name: "Stoppage",
  components: { StoppageAddUpdateModal, BoardingPlace, DroppingPlace },
  setup() {
    let pagination = reactive({
      page: 1,
      limit: 25,
      companyId: "",
    });
    const addUpdate = ref(false);
    const stoppageId = ref("");
    let defaultIndex = ref("");
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const options = {
      texts: {
        count: "",
      },
    };

    const boardingPlace = ref(false);
    const droppingPlace = ref(false);
    const stoppageName = ref("");

    const route = useRoute();
    const updateBoardingPlace = (id, index, selectedStoppageName) => {
      stoppageId.value = id;
      defaultIndex.value = index;
      boardingPlace.value = true;
      stoppageName.value = selectedStoppageName;
    };
    const updateDroppingPlace = (id, index, selectedStoppageName) => {
      stoppageId.value = id;
      defaultIndex.value = index;
      droppingPlace.value = true;
      stoppageName.value = selectedStoppageName;
    };
    const getAllStoppages = () => {
      showLoader();
      store
        .dispatch("getStoppagesByPage", pagination)
        .then(() => {
          hideLoader();
        })
        .catch((error) => {
          hideLoader();
          if (error.status === 401) {
            getAllStoppages();
          }
        });
    };
    const getDigitalTicketingAllStoppages = () => {
      store
          .dispatch("getDigitalTicketingAllStoppages")
    }
    const close = () => {
      addUpdate.value = false;
    };
    const addModal = () => {
      stoppageId.value = "";
      addUpdate.value = true;
    };
    const updateModal = (id) => {
      stoppageId.value = id;
      addUpdate.value = true;
    };

    const toggle = () => {
      stoppageId.value = "";
      if (boardingPlace.value || droppingPlace.value) {
        boardingPlace.value = false;
        droppingPlace.value = false;
      } else {
        addUpdate.value = !addUpdate.value;
      }
    };

    // const getCityName = (cityId) => {
    //   return store.getters.getDigitalTicketingAllStoppages
    // }

    onBeforeMount(() => {
      getDigitalTicketingAllStoppages();
      if (route.query.id) {
        pagination.companyId = route.query.id;
        getAllStoppages();
      }
    });

    return {
      options,
      pagination,
      dropdownVariables,
      addUpdate,
      stoppageId,
      Admin,
      hasPermission,
      getAllStoppages,
      addModal,
      updateModal,
      close,
      updateBoardingPlace,
      updateDroppingPlace,
      boardingPlace,
      droppingPlace,
      toggle,
      defaultIndex,
      stoppageName
    };
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
